import React from 'react'
import { useTranslation } from 'react-i18next';

const TipConfiguration = () => {
    const { t } = useTranslation();
    // const navigate = useNavigate();
    return (
        <main id='main-content'>
            <div className='inner-container'>
            <div className='page-header d-flex align-items-center'>
                    <h4 className='heading-title-text'>{t('restaurant.tip.label_tip')}</h4>
                </div>
                TipConfiguration
            </div>
        </main>
    )
}

export default TipConfiguration
